import type { Component } from "solid-js";
import type { IconProps } from "./types";

const AnthropicIcon: Component<IconProps> = (props = {}) => {
  const size = props.size || 16;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 176"
      fill="currentColor"
      width={size}
      height={size}
      class={props.class}
    >
      <path d="m147.487 0l70.081 175.78H256L185.919 0zM66.183 106.221l23.98-61.774l23.98 61.774zM70.07 0L0 175.78h39.18l14.33-36.914h73.308l14.328 36.914h39.179L110.255 0z" />
    </svg>
  );
};

export default AnthropicIcon;
